import produce from 'immer';

import * as actions from './actions';

export default produce((state, action) => {
  switch (action.type) {

  case actions.SET_PLAYBOOKS:
    for (const playbook of action.playbooks) {
      for (const stage in playbook.tasksByStage) {
        playbook.tasksByStage[stage].sort((a, b) => a.sortOrder - b.sortOrder);
      }
    }

    return action.playbooks;

  case actions.ADD_FIELD:
    findPlaybook(state, action).fieldsByStage[action.field.stage].push(action.field);
    break;

  case actions.CHANGE_FIELD: {
    const fields = findPlaybook(state, action).fieldsByStage[action.field.stage];
    const index = findIndexByName(fields, action.field);
    fields[index] = { ...fields[index], ...action.changes };
    break;
  }

  case actions.DELETE_FIELD: {
    const fields = findPlaybook(state, action).fieldsByStage[action.field.stage];
    fields.splice(findIndexByName(fields, action.field), 1);
    break;
  }

  case actions.ADD_TASK:
    findPlaybook(state, action).tasksByStage[action.task.stage].push(action.task);
    break;

  case actions.REPLACE_TASK: {
    const tasks = findPlaybook(state, action).tasksByStage[action.task.stage];
    const index = findIndexByName(tasks, action.task);
    tasks[index] = action.updatedTask;
    break;
  }

  case actions.CHANGE_TASK: {
    const playbook = findPlaybook(state, action);
    const task = findTask(playbook, action.task);
    for (const key in action.changes) {
      task[key] = action.changes[key];
    }

    break;
  }

  case actions.DELETE_TASK: {
    const tasks = findPlaybook(state, action).tasksByStage[action.task.stage];
    tasks.splice(findIndexByName(tasks, action.task), 1);
    break;
  }

  case actions.REORDER_TASKS: {
    const tasks = findPlaybook(state, action).tasksByStage[action.stage];

    let sourceTask, targetTask;
    for (const task of tasks) {
      if (task.id === action.sourceTaskId) {
        sourceTask = task;
      } else if (task.id === action.targetTaskId) {
        targetTask = task;
      }

      if (sourceTask && targetTask) {
        const sourceSortOrder = sourceTask.sortOrder;
        sourceTask.sortOrder = targetTask.sortOrder;
        targetTask.sortOrder = sourceSortOrder;
        tasks.sort((a, b) => a.sortOrder - b.sortOrder);
        break;
      }
    }

    break;
  }
  }
}, null);

function findPlaybook(state, action) {
  return state.find(playbook => playbook.id === action.playbook.id);
}

function findIndexByName(fields, field) {
  return fields.findIndex(({ name }) => field.name === name);
}

function findTask(playbook, task) {
  return playbook.tasksByStage[task.stage].find(({ id }) => task.id === id);
}
